query GetTrainingModules {
  trainingModules {
    id
    title
    slug
    controlReference
    status
    audience
    teams {
      id
      name
    }
    position
    hasVideo
    activeQuestionCount
    questionsPerAttempt
    updatedAt
  }
}
